/** @format */

export function commaNumber(value) {
  if (value === null || value === undefined) {
    return '';
  }
  if (isNaN(value)) {
    return value;
  } else {
    return (value + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
  }
}
